import { INITIAL_PAGE_SIZE, SHOW_ALL_THRESHOLD, MAX_CLICKS } from './constants'

/**
 * Returns the step size used when clicking "Show more" for a given tab.
 *
 * - If total ≤ SHOW_ALL_THRESHOLD: reveal everything at once (no button needed).
 * - Otherwise: divide the cards *remaining after the initial view* evenly across
 *   MAX_CLICKS steps, so the user always reaches the end in exactly MAX_CLICKS clicks.
 */
export const getStepSize = (total: number): number => {
  if (total <= SHOW_ALL_THRESHOLD) return total
  return Math.ceil((total - INITIAL_PAGE_SIZE) / MAX_CLICKS)
}

/**
 * Builds the initial visibleCount map for all tabs.
 * Always starts at INITIAL_PAGE_SIZE (12) regardless of tab size.
 */
export const buildInitialVisibleCount = (tabs: string[]): Record<string, number> =>
  Object.fromEntries(tabs.map((tab) => [tab, INITIAL_PAGE_SIZE]))
